<template>
  <div id="header">
    <!-- nav样式2 -->
    <div class="nav-global">
      <div class="container">
        <ul class="nav-aside2">
          <li class="nav-user" @click="userData != null ? '' : onLogin()">
            <a href="javascript:;">个人中心</a>
            <!--active-->
            <div class="nav-user-wrapper" v-if="userData != null">
              <div class="nav-user-list">
                <dl class="nav-user-avatar">
                  <dd><span class="ng-scope"></span></dd>
                  <dt class="ng-binding">+86 {{ userData.user_name }}</dt>
                </dl>
                <ul>
                  <li class="order"><a href="javascript:;">我的订单</a></li>
                  <li class="support"><a href="javascript:;">售后服务</a></li>
                  <li class="coupon"><a href="javascript:;">我的优惠</a></li>
                  <li class="address"><a href="javascript:;">收货地址</a></li>
                  <li class="logout" @click="logout()">
                    <a href="javascript:;">退出</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!--active 购物车-->
          <car-panel></car-panel>
        </ul>
        <h1 class="nav-logo2">{{ COMPANY_NAME }}</h1>

      </div>
    </div>
    <ul class="nav-list2">
      <li :class="{ active: routerName == '' }">
        <router-link to="/">首页</router-link>
      </li>
      <!-- <li :class="{ active: routerName == 'goodsList' }">
            <router-link to="/goodsList">商品分类</router-link>
          </li> -->
      <li :class="{ active: routerName == 'storeEnter' }">
        <router-link to="storeEnter">商户申请</router-link>
      </li>
      <li :class="{ active: routerName == 'cityInfo' }">
        <router-link to="cityInfo">邻友互助</router-link>
      </li>
      <!-- <li :class="{ active: routerName == 'cityInfo' }">
            <router-link to="cityInfo">同城信息</router-link>
          </li> -->
      <!-- <li :class="{ active: routerName == 'storeEnter' }">
            <router-link to="/storeEnter">商家入驻</router-link>
          </li> -->
      <li :class="{ active: routerName == 'publishInfo' }">
        <router-link to="/publishInfo">我也要发帖</router-link>
      </li>
      <li>
        <a @click="onNotify()">投诉与建议</a>
      </li>
    </ul>

    <div></div>
    <loginDialog :isLoginDialog.sync="isLoginDialog" @resData="resData" class="dialog" />
    <!-- 弹窗 -->
    <prompt></prompt>
  </div>
</template>

<script>
import login from "@/components/login";
import carPanel from "@/components/car-panel.vue";
import Prompt from "./prompt.vue";
export default {
  data() {
    return {
      isLoginDialog: false,
      userData: {},
      routerName: this.$route.path.split("/")[1], //路由里的根路由
    };
  },
  created() {
    this.$notify({
      title: '联系我们',
      message: '邮箱：' + this.EMAIL + ' 24小时客服热线：17773110826',
      duration: 0,
      offset: 100
    });
    //获取本地存储的旧数据
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.userData = userData;
    if (this.userData != null) {
      this.$axios
        .get(`/getGoodsCar?user_id=${userData.user_id}`)
        .then((res) => {
          let resData = res.data.data;
          console.log(resData);
          this.$store.commit("setCarPanelData", resData);
        });
    }
  },
  methods: {
    onNotify() {
      this.$notify({
        title: '联系我们',
        message: '邮箱：' + this.EMAIL + ' 24小时客服热线：17773110826',
        offset: 100
      });
    },
    resData(data) {
      this.userData = data;
    },
    logout() {
      localStorage.clear("userData");
      this.userData = {};
      location.reload();
    },
    onLogin() {
      this.isLoginDialog = true;
    },
  },
  watch: {
    $route(to, from) {
      //监听路由name，操作导航栏样式
      this.routerName = to.path.split("/")[1]; //路由里的根路由
    },
  },
  components: {
    carPanel,
    Prompt,
    loginDialog: login,
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/header-nav.vue